import React from "react";

const SemiCircularProgress = ({ value, type }) => {
  // Define reasonable limits
  const min = type === "volume" ? 0 : 0; 
  const max = type === "volume" ? 100 : 10; 

  // Ensure value is within range
  const clampedValue = Math.min(Math.max(value, min), max);
  const percentage = ((clampedValue - min) / (max - min)) * 100;

  // Define a single consistent color
  const primaryColor = "#3A5AFE"; // Blue for both Volume & Pace

  // Status Labels
  const getStatus = (val) => {
    if (type === "volume") {
      if (val < 30) return "Low";
      if (val < 60) return "Good";
      return "Loud";
    } else if (type === "pace") {
      if (val < 3) return "Slow";
      if (val < 7) return "Good";
      return "Fast";
    }
  };
  const strokeDashArray = (percentage / 100) * 188;
  return (
    
    <div className="flex flex-col items-center w-full p-4 rounded-lg bg-white" style={{ boxShadow:'0px 0px 4px 0px #00000040 '}}>
      <h3 className="text-lg font-semibold text-gray-700 capitalize">
        {type} Analysis
      </h3>

      {/* Progress Bar Container */}
      <div className="relative w-full flex justify-center">
        {/* <svg width="160" height="100" viewBox="0 0 160 100">
          
          <path
            d="M 20 80 A 60 60 0 0 1 140 80"
            fill="none"
            stroke="#E3E7FF"
            strokeWidth="12"
          />
          <path
            d="M 20 80 A 60 60 0 0 1 140 80"
            fill="none"
            stroke={primaryColor}
            strokeWidth="12"
            strokeDasharray={`${(percentage / 100) * Math.PI * 60}, 314`}
            strokeLinecap="round"
          />
        </svg> */}
        <svg width="140" height="100" viewBox="0 0 160 100">
          {/* Background Arc */}
          <path
            d="M 20 80 A 60 60 0 0 1 140 80"
            fill="none"
            stroke="#E3E7FF"
            strokeWidth="5"
          />
          {/* Progress Arc */}
          <path
            d="M 20 80 A 60 60 0 0 1 140 80"
            fill="none"
            stroke="#2C72F2"
            strokeWidth="12"
            strokeDasharray={`${strokeDashArray} 188`}
            
          />
        </svg>
      </div>

      {/* Display Value */}
      <p className="text-lg font-semibold text-gray-800">
        {clampedValue} {type === "volume" ? "dB" : type === "tone" ? "Pts" : "SPS"}
      </p>

      {/* Status Label */}
      {getStatus(clampedValue) ?(
      <span className={`mt-2 px-3 py-1 text-blue-700 bg-blue-100 rounded-lg`}>
        {getStatus(clampedValue)}
      </span>):null}
    </div>
  );
};

export default SemiCircularProgress;
